export function isValidImageUpload(files) {
  return files.length && /^image/.test(files[0].type)
}

export function readAsDataURL(file) {
  if (!file) return Promise.resolve(null)

  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = (e) => resolve(e.target.result)
    reader.readAsDataURL(file)
  })
}
